// import Vue from 'vue'
///////////////////////////////////////////////////////
/// ABERTURA DA INSERÇÃO DOS COMPONENTS DGP GLOBAIS ///
///////////////////////////////////////////////////////
import SGPTabelaComponent from '@/common/sgp-components/SGPTabelaComponent';
import SGPBotaoAdicionarNovoComponent from '@/common/sgp-components/SGPBotaoAdicionarNovoComponent';
import SGPModalComponent from '@/common/sgp-components/SGPModalComponent';
import SGPModalImagemComponent from '@/common/sgp-components/SGPModalImagemComponent';
import SGPConfirmacaoDelecaoComponent from '@/common/sgp-components/SGPConfirmacaoDelecaoComponent';
import SGPConfirmacaoRestauracaoComponent from '@/common/sgp-components/SGPConfirmacaoRestauracaoComponent';
import SGPAlertaComponent from '@/common/sgp-components/SGPAlertaComponent';
import SGPLoadingComponent from '@/common/sgp-components/SGPLoadingComponent';
import SGPAssociarComponent from '@/common/sgp-components/SGPAssociarComponent';
import SGPFormSelectComponent from '@/common/sgp-components/SGPFormSelectComponent';
import SGPFormInputComponent from '@/common/sgp-components/SGPFormInputComponent';
import SGPMainTabComponent from '@/common/sgp-components/SGPTab/SGPMainTabComponent';
import SGPTabComponent from '@/common/sgp-components/SGPTab/SGPTabComponent';
import SGPBotaoVoltarComponent from '@/common/sgp-components/SGPBotaoVoltarComponent';
import SGPPaginacaoComponent from '@/common/sgp-components/SGPPaginacaoComponent';
import SGPBoxHeaderInfoComponent from '@/common/sgp-components/SGPBoxHeaderInfoComponent';
import SGPFiltroInputBuscaComponent from '@/common/sgp-components/SGPFiltroInputBuscaComponent';
import SGPFormFilterComponent from '@/common/sgp-components/SGPFormFilterComponent';
import SGPFiltroComponent from '@/common/sgp-components/SGPFiltros/SGPFiltroComponent';
import SGPCustomTagsComponent from '@/common/sgp-components/SGPFiltros/SGPCustomTagsComponent';
import SGPFormToggleComponent from '@/common/sgp-components/SGPFormToggleComponent';
import SGPFormDataComponent from '@/common/sgp-components/SGPFormDataComponent';
import SGPFormDataRangeComponent from '@/common/sgp-components/SGPFormDataRangeComponent';
import SGPFormSemanaComponent from '@/common/sgp-components/SGPFormSemanaComponent';
import SGPFormAnoComponent from '@/common/sgp-components/SGPFormAnoComponent';
import SGPFormMesComponent from '@/common/sgp-components/SGPFormMesComponent';
import SGPFormHoraComponent from '@/common/sgp-components/SGPFormHoraComponent';
import SGPFormBotaoComponent from '@/common/sgp-components/SGPFormBotaoComponent';
import SGPDrawerComponent from '@/common/sgp-components/SGPDrawerComponent';
import SGPContainerComponent from '@/common/sgp-components/SGPContainerComponent';
import SGPRowComponent from '@/common/sgp-components/SGPRowComponent';
import SGPColComponent from '@/common/sgp-components/SGPColComponent';
import SGPFormCheckboxComponent from '@/common/sgp-components/SGPFormCheckboxComponent';
import SGPConfirmacaoComponent from '@/common/sgp-components/SGPConfirmacaoComponent';
import SGPPageHeaderComponent from '@/common/sgp-components/SGPPageHeaderComponent'
import SGPContadorRecarregamentoComponent from '@/common/sgp-components/SGPContadorRecarregamento/SGPContadorRecarregamentoComponent'
import SGPTabelaAvancadaComponent from '@/common/sgp-components/SGPTabelaAvancadaComponent/SGPTabelaAvancadaComponent'
import SGPPermissionamentoComponent from '@/common/sgp-components/SGPPermissionamento/SGPPermissionamentoComponent'
import SGPIconComponent from '@/common/sgp-components/SGPIconComponent/SGPIconComponent'
import SGPFormAutocompleteComponent from '@/common/sgp-components/SGPFormAutocompleteComponent'
import SGPTabsMenuHorizontalComponent from '@/common/sgp-components/SGPOrdemServico/SGPTabsMenuHorizontalComponent'
import SGPTabsMenuVerticalComponent from '@/common/sgp-components/SGPOrdemServico/SGPTabsMenuVerticalComponent'
import SGPDynamicImportComponent from '@/common/sgp-components/SGPOrdemServico/SGPDynamicImportComponent'
import OSFormComboboxComponent from '@/common/sgp-components/SGPOrdemServico/OSFormComboboxComponent'
import SGPRadioGroupComponent from '@/common/sgp-components/SGPRadioGroup/SGPRadioGroupComponent'
import SGPBoxPorcentagemComponent from '@/common/sgp-components/SGPBoxPorcentagemComponent/SGPBoxPorcentagemComponent'
import SGPGraficoComponent from '@/common/sgp-components/SGPGraficoComponent/SGPGraficoComponent'
import SGPGridComponent from '@/common/sgp-components/SGPGridComponent/SGPGridComponent'
import SGPGridBoxComponent from '@/common/sgp-components/SGPGridComponent/SGPGridBoxComponent'
import SGPTextTooltipComponent from '@/common/sgp-components/SGPTextTooltipComponent'

import SGPFiltroAvancadoComponent from '@/common/sgp-components/SGPFiltroAvancadoComponent';
export default {
    install (Vue) {
      Vue.component('SGPTabelaComponent', SGPTabelaComponent)
      Vue.component('SGPConfirmacaoComponent', SGPConfirmacaoComponent)
      Vue.component('SGPBotaoAdicionarNovoComponent', SGPBotaoAdicionarNovoComponent)
      Vue.component('SGPModalComponent', SGPModalComponent)
      Vue.component('SGPModalImagemComponent', SGPModalImagemComponent)
      Vue.component('SGPConfirmacaoDelecaoComponent', SGPConfirmacaoDelecaoComponent)
      Vue.component('SGPConfirmacaoRestauracaoComponent', SGPConfirmacaoRestauracaoComponent)
      Vue.component('SGPAlertaComponent', SGPAlertaComponent)
      Vue.component('SGPLoadingComponent', SGPLoadingComponent)
      Vue.component('SGPAssociarComponent', SGPAssociarComponent)
      Vue.component('SGPFormSelectComponent', SGPFormSelectComponent)
      Vue.component('SGPFormInputComponent', SGPFormInputComponent)
      Vue.component('SGPMainTabComponent', SGPMainTabComponent)
      Vue.component('SGPTabComponent', SGPTabComponent)
      Vue.component('SGPBotaoVoltarComponent', SGPBotaoVoltarComponent)
      Vue.component('SGPPaginacaoComponent', SGPPaginacaoComponent)
      Vue.component('SGPBoxHeaderInfoComponent', SGPBoxHeaderInfoComponent)
      Vue.component('SGPFiltroInputBuscaComponent', SGPFiltroInputBuscaComponent)
      Vue.component('SGPFormFilterComponent', SGPFormFilterComponent)
      Vue.component('SGPFiltroComponent', SGPFiltroComponent)
      Vue.component('SGPCustomTagsComponent', SGPCustomTagsComponent)
      Vue.component('SGPFormToggleComponent', SGPFormToggleComponent)
      Vue.component('SGPFormDataComponent', SGPFormDataComponent)
      Vue.component('SGPFormDataRangeComponent', SGPFormDataRangeComponent)
      Vue.component('SGPFormSemanaComponent', SGPFormSemanaComponent)
      Vue.component('SGPFormAnoComponent', SGPFormAnoComponent)
      Vue.component('SGPFormMesComponent', SGPFormMesComponent)
      Vue.component('SGPFormHoraComponent', SGPFormHoraComponent)
      Vue.component('SGPFormBotaoComponent', SGPFormBotaoComponent)
      Vue.component('SGPDrawerComponent', SGPDrawerComponent)
      Vue.component('SGPContainerComponent', SGPContainerComponent)
      Vue.component('SGPRowComponent', SGPRowComponent)
      Vue.component('SGPColComponent', SGPColComponent)
      Vue.component('SGPFormCheckboxComponent', SGPFormCheckboxComponent)
      Vue.component('SGPPageHeaderComponent', SGPPageHeaderComponent)
      Vue.component('SGPContadorRecarregamentoComponent', SGPContadorRecarregamentoComponent)
      Vue.component('SGPTabelaAvancadaComponent', SGPTabelaAvancadaComponent)
      Vue.component('SGPPermissionamentoComponent', SGPPermissionamentoComponent)
      Vue.component('SGPIconComponent', SGPIconComponent)
      Vue.component('SGPFormAutocompleteComponent', SGPFormAutocompleteComponent)
      Vue.component('SGPTabsMenuHorizontalComponent', SGPTabsMenuHorizontalComponent)
      Vue.component('SGPTabsMenuVerticalComponent', SGPTabsMenuVerticalComponent)
      Vue.component('SGPDynamicImportComponent', SGPDynamicImportComponent)
      Vue.component('OSFormComboboxComponent', OSFormComboboxComponent)
      Vue.component('SGPRadioGroupComponent', SGPRadioGroupComponent)
      Vue.component('SGPBoxPorcentagemComponent', SGPBoxPorcentagemComponent)
      Vue.component('SGPGraficoComponent', SGPGraficoComponent)
      Vue.component('SGPFiltroAvancadoComponent', SGPFiltroAvancadoComponent)
      Vue.component('SGPGridComponent', SGPGridComponent)
      Vue.component('SGPGridBoxComponent', SGPGridBoxComponent)
      Vue.component('SGPTextTooltipComponent', SGPTextTooltipComponent)
  }
}